import React from "react";
import type { StateUpdate } from "@ps-bridge/capabilitiesTypes";
import type { ClientsViewProps } from "@ps-bridge/contracts/clients";
import type { Ok } from "@ps-bridge/ok";
import type { Client } from "@ps-bridge/models/core/dataContracts";
import * as IO from "@ps-bridge/interop/io";
import ClientsPanel, {
  type ClientsPanelEmptyResultPhase,
  type ClientsPanelToolbarPhase,
} from "@view/panels/workspace/clients/ClientsPanel.panel";

type ClientsPanelContractProps = Pick<
  ClientsViewProps,
  "clients" | "activeClientId" | "onNavigateClient"
>;

type ClientsPanelViewProps = ClientsPanelContractProps & {
  filteredClients: Client[];
  clientQuery: string;
  clientQueryOptions: Client[];
  clientEmptyText: string;
  clientCreationEnabled: boolean;
  onClientQueryChange: StateUpdate<string>;
  onCreateClient: () => Ok;
  runIO: typeof IO.run;
  formatTime: (value: string) => string;
};

const ClientsPanelView: React.FC<ClientsPanelViewProps> = ({
  clients,
  filteredClients,
  activeClientId,
  clientQuery,
  clientQueryOptions,
  clientEmptyText,
  clientCreationEnabled,
  onClientQueryChange,
  onCreateClient,
  onNavigateClient,
  runIO,
  formatTime,
}) => {
  const toolbarPhase: ClientsPanelToolbarPhase =
    clients.length === 0 ? (clientCreationEnabled ? "empty" : "emptyHidden") : "search";
  const emptyResultPhase: ClientsPanelEmptyResultPhase =
    filteredClients.length === 0 && clients.length > 0 ? "visible" : "hidden";

  return (
    <ClientsPanel
      clients={clients}
      filteredClients={filteredClients}
      activeClientId={activeClientId}
      clientQuery={clientQuery}
      clientQueryOptions={clientQueryOptions}
      clientEmptyText={clientEmptyText}
      toolbarPhase={toolbarPhase}
      emptyResultPhase={emptyResultPhase}
      onClientQueryChange={onClientQueryChange}
      onCreateClient={onCreateClient}
      onNavigateClient={onNavigateClient}
      runIO={runIO}
      formatTime={formatTime}
    />
  );
};

export default ClientsPanelView;
